<template>
  <el-dialog
      :model-value="props.visible"
      title="您是否有就业需求？"
      width="500"
      top="30vh"
      :show-close="false"
      :close-on-press-escape="false"
      destroy-on-close
      :close-on-click-modal="false"
      @open="onOpen"
      @closed="closedModal"
  >
    <div v-loading="pageLoading">
      <div style="max-height: calc(80vh - 100px);overflow-y: auto;">
        <el-form :model="formData" ref="formRef" :rules="rules" :inline="true" label-width="120px">

          <el-form-item label="状态" prop="hasJobIntention">
            <el-radio-group v-model="formData.hasJobIntention">
              <el-radio :value="0">暂无就业需求</el-radio>
              <el-radio :value="1">有就业需求</el-radio>
            </el-radio-group>
          </el-form-item>

        </el-form>
      </div>

      <div class="my-footer">
        <el-button type="primary" style="margin-right: 15px;" @click="onConfirm">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ElMessage} from "element-plus";
import CitySelect from '@/components/CitySelect'
import {submitOne} from "@/api/myJob/index.js";

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
})

const pageLoading = ref(false)
const formData = ref({})
const rules = reactive({
  hasJobIntention: [
    {required: true, message: '请选择', trigger: 'change'},
  ]
})

function onOpen() {
}

const formRef = ref()

const emit = defineEmits(['update:visible', 'refresh'])

async function onConfirm() {
  await formRef.value.validate(valid => {
    if (valid) {
      pageLoading.value = true
        submitOne({
        ...formData.value,
      })
          .then(res => {
            if (res.code === 200) {
              ElMessage.success('操作成功')
              emit('update:visible', false)
              emit('refresh')
            }
          })
          .finally(() => {
            pageLoading.value = false
          })
    }
  })
}

function closedModal() {
  emit('update:visible', false)
  formData.value = {}
}
</script>

<style scoped lang="scss">
.my-footer {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 30px;
}
</style>
